"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlatformAuthError = void 0;
const tiktok_media_1 = require("./tiktok-media");
const platform_enum_1 = require("./types/platform.enum");
const youtube_media_1 = require("./youtube-media");
const META_AUTH_ERROR = /token is invalid|invalid (page )?access token|oauthexception|error validating access token|session has expired|(#190|#102)|unauthorized|401|revoked|expired/i;
const PLATFORM_AUTH_PATTERNS = {
    [platform_enum_1.PlatformEnum.FACEBOOK]: META_AUTH_ERROR,
    [platform_enum_1.PlatformEnum.INSTAGRAM]: META_AUTH_ERROR,
    [platform_enum_1.PlatformEnum.THREADS]: META_AUTH_ERROR,
    [platform_enum_1.PlatformEnum.LINKEDIN]: /unauthorized|401|403|invalid.?token|token.*expired|revoked|expired/i,
    [platform_enum_1.PlatformEnum.GOOGLE_BUSINESS]: /unauthorized|invalid_grant|invalid_token|token.*expired|401|403|revoked/i,
    [platform_enum_1.PlatformEnum.WORDPRESS]: /unauthorized|401|403|rest_forbidden|incorrect_password|invalid.?user|application.?password|forbidden/i,
    [platform_enum_1.PlatformEnum.X]: /unauthorized|401|403|invalid.?token|token.*expired|access token|reconnect x|oauth|forbidden|revoked/i,
};
/** Detect OAuth/token errors that require reconnecting a platform. */
const isPlatformAuthError = (platform, message) => {
    var _a, _b;
    if (!message.trim()) {
        return false;
    }
    if (platform === platform_enum_1.PlatformEnum.YOUTUBE) {
        return (0, youtube_media_1.isYouTubeAuthError)(message);
    }
    if (platform === platform_enum_1.PlatformEnum.TIKTOK) {
        return (0, tiktok_media_1.isTikTokAuthError)(message);
    }
    return ((_b = (_a = PLATFORM_AUTH_PATTERNS[platform]) === null || _a === void 0 ? void 0 : _a.test(message)) !== null && _b !== void 0 ? _b : false);
};
exports.isPlatformAuthError = isPlatformAuthError;
